import NavBar from "../../structure/NavBar"
import InputGroup from "react-bootstrap/InputGroup";
import { Dropdown, Form } from 'react-bootstrap'
import Switch from '@mui/material/Switch'
import AddIcon from '@mui/icons-material/Add'
import { NavBarTop } from "../../structure/NavBarTop"
import { useEffect, useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import { updateLoading } from "../../../redux/features/common/commonSlice"
import urls from "../../constants/apiurl"
import ApiCaller from "../../constants/ApiCaller"
import { showDangerToast, showToast } from "../../constants/toaster"
import { useNavigate } from "react-router-dom";
const label = { inputProps: { 'aria-label': 'Size switch demo' } }
export const AddCountryRoutingConfig = () => {
    const navigate = useNavigate()
    const dispatch = useDispatch()
    const [wowzaHost, setWowzaHost] = useState([]);
    const [reelHost, setReelHost] = useState([]);
    const [m3u8Enable, setM3u8Enable] = useState(false);
    const [routingHostConfigResponse, setRoutingHostConfigResponse] = useState({});
    const userData = useSelector((state) => state?.userData);
    const [countryDropdownText, setCountryDropdownText] = useState({
        id: '',
        lable: 'Select Country'
    })
    const [countryCodeList, setCountryCodeList] = useState([
        {
            id: '',
            name: 'Select Country'
        }
    ])

    const [countryNetworkServiceProviderDataList, setCountryNetworkServiceProviderDataList] = useState([])


    useEffect(() => {
        getCountryCodeList()
    }, [])

    const handleInputChange = (type, key, value, valueType) => {
        if (type === 1) {
            setReelHost((prevState) => {
                // Check if the key already exists
                const existingIndex = prevState.findIndex((item) => item.id === key);

                if (existingIndex !== -1) {
                    // Update the existing entry
                    const updatedState = [...prevState];
                    updatedState[existingIndex].host = value;
                    return updatedState;
                } else {
                    // Add a new entry
                    return [...prevState, { id: key, host: value }];
                }
            });
        } else {
            setWowzaHost((prevState) => {
                // Check if the key already exists
                const existingIndex = prevState.findIndex((item) => item.id === key);

                if (existingIndex !== -1) {
                    // Update the existing entry
                    const updatedState = [...prevState];
                    if (valueType === 'host') {
                        updatedState[existingIndex].host = value;
                    } else {
                        updatedState[existingIndex].playBackUrl = value;
                    }
                    return updatedState;
                } else {
                    // Add a new entry
                    if (valueType === 'host') {
                        return [...prevState, { id: key, host: value, playBackUrl: '' }];
                    } else {
                        return [...prevState, { id: key, host: '', playBackUrl: value }];
                    }
                }
            });
        }
    };

    const getReelHostValue = (key) => {
        const hostObj = reelHost.find((item) => item.id === key);
        return hostObj ? hostObj.host : ""; // Return the host value if found, otherwise an empty string
    };
    const getWowzaHostValue = (key, type) => {
        const hostObj = wowzaHost.find((item) => item.id === key);
        if (type === 'host') {
            return hostObj ? hostObj.host : ""; // Return the host value if found, otherwise an empty string
        } else {
            return hostObj ? hostObj.playBackUrl : ""; // Return the host value if found, otherwise an empty string
        }
    };



    const getCountryCodeList = async () => {
        try {
            dispatch(updateLoading(true))
            let path = urls.countryCodeList
            let res = await ApiCaller.get({}, path, userData?.access_token)
            const response = await res.response.json()
            if (response.status == 200) {
                dispatch(updateLoading(false))
                let tempArray = []
                tempArray.push(...response?.data)
                setCountryCodeList(tempArray)
            } else {
                dispatch(updateLoading(false))
                showDangerToast(response.message)
            }
        } catch (error) {
            dispatch(updateLoading(false))
            console.error(error)
            showDangerToast(error.message)
        }
    }
    const getCountryNetworkProviderList = async (id) => {
        try {
            dispatch(updateLoading(true))
            let path = urls.networkProviderKeyValueByCountry + "?countryId=" + id
            let res = await ApiCaller.get({}, path, userData?.access_token)
            const response = await res.response.json()
            if (response.status == 200) {
                dispatch(updateLoading(false))
                let tempArray = []
                tempArray.push(...response?.data)
                if (tempArray?.length) {
                    tempArray.push({
                        "key": "OTHER",
                        "value": "Other"
                    })
                }
                setCountryNetworkServiceProviderDataList(tempArray)
                // getRoutingHostConfig(id);
            } else {
                dispatch(updateLoading(false))
                showDangerToast(response.message)
            }
        } catch (error) {
            dispatch(updateLoading(false))
            console.error(error)
            showDangerToast(error.message)
        }
    }


    const getRoutingHostConfig = async (id) => {
        try {
            dispatch(updateLoading(true))
            let path = urls.getRoutingHostConfigDetails + "?countryId=" + id
            let res = await ApiCaller.get({}, path, userData?.access_token)
            const response = await res.response.json()
            if (response.status == 200) {
                dispatch(updateLoading(false))
                setRoutingHostConfigResponse(response?.data)
                setM3u8Enable(response?.data?.m3u8Enable)
                if (response?.data?.reelHostNetworkProviders) {
                    setReelHost(response?.data?.reelHostNetworkProviders)
                }
                if (response?.data?.wowzaHostNetworkProviders) {
                    setWowzaHost(response?.data?.wowzaHostNetworkProviders)
                }
                getCountryNetworkProviderList(id)
            } else {
                dispatch(updateLoading(false))
                showDangerToast(response.message)
            }
        } catch (error) {
            dispatch(updateLoading(false))
            console.error(error)
            showDangerToast(error.message)
        }
    }

    const handleSubmitRoutingConfig = async () => {
        let postJson = {
            countryId: countryDropdownText?.id,
            reelHostNetworkProviders: reelHost,
            wowzaHostNetworkProviders: wowzaHost,
            m3u8Enable: m3u8Enable
        }
        try {
            dispatch(updateLoading(true))
            let path = urls.routingHostConfigAddUpdate
            let res = await ApiCaller.post(postJson, path, userData?.access_token)
            const response = await res.response.json()
            if (response.status == 200) {
                dispatch(updateLoading(false))
                showToast(response?.message)
                setCountryDropdownText({
                    id: '',
                    lable: 'Select Country'
                })
                setReelHost([])
                setWowzaHost([])
                setCountryNetworkServiceProviderDataList([])
                // navigate('/routing-manager')
            } else {
                dispatch(updateLoading(false))
                showDangerToast(response.message)
            }
        } catch (error) {
            dispatch(updateLoading(false))
            console.error(error)
            showDangerToast(error.message)
        }
    }

    return <>
        <NavBar />
        <div className='main-content'>
            <NavBarTop />
            <div className='header'>
                <div className='logo'>
                    <div className='header bg-gradient-primary pb-8 pt-5 pt-md-8'></div>
                </div>
            </div>
            <div className='container-fluid mt--7'>
                <div className='row'>
                    <div className='col text-left'>
                        <div className='card shadow'>
                            <div className='card-header border-0'>
                                <div className='row align-items-center text-left'>
                                    <div className='col-10'>
                                        <h3 className='mb-0'>Add Country Routing Config</h3>
                                    </div>
                                    <div className='col-2'>
                                        <a
                                            onClick={() => handleSubmitRoutingConfig()}
                                            className='btn btn-sm btn-primary text-white'
                                        >
                                            <AddIcon />
                                            Submit
                                        </a>
                                    </div>
                                </div>
                                <div className='row' style={{ padding: '20px' }}>
                                    <div className='col-12'>
                                        <Form>
                                            <Form.Group
                                                className='mb-3' style={{ display: 'grid' }}
                                                controlId='exampleForm.ControlInput1'
                                            >
                                                <Form.Label>Country*</Form.Label>
                                                <Dropdown>
                                                    <Dropdown.Toggle
                                                        variant='success'
                                                        style={{
                                                            backgroundColor: 'white',
                                                            color: 'black',
                                                            border: '1px solid #cad1d7',
                                                            boxShadow: 'none',
                                                            transform: 'none'
                                                        }}
                                                        id='dropdown-basic'
                                                    >
                                                        {countryDropdownText?.lable}
                                                    </Dropdown.Toggle>
                                                    <Dropdown.Menu>
                                                        {countryCodeList?.map((item, i) => {
                                                            return (
                                                                <>
                                                                    <Dropdown.Item
                                                                        eventKey={item?.id}
                                                                        onClick={() => {
                                                                            setCountryDropdownText({
                                                                                id: item?.id,
                                                                                lable: item?.name
                                                                            })
                                                                            getRoutingHostConfig(item?.id)
                                                                        }}
                                                                    >
                                                                        {item?.name}
                                                                    </Dropdown.Item>
                                                                </>
                                                            )
                                                        })}
                                                    </Dropdown.Menu>
                                                </Dropdown>
                                            </Form.Group>
                                        </Form>
                                    </div>
                                    <div className="col-md-6" style={{
                                        border: '1px solid #dbdbdb',
                                        borderRadius: '10px'
                                    }}>
                                        <Form>
                                            <Form.Group
                                                className='mb-3' style={{ display: 'grid', padding: '10px' }}
                                                controlId='exampleForm.ControlInput1'
                                            >
                                                <h5>Reel Host*</h5>
                                                <div className="row">
                                                    {countryNetworkServiceProviderDataList?.map((data, index) => {
                                                        return < >
                                                            <div className="col-md-3 d-flex justify-content-center align-items-center">
                                                                <h5>{data?.value}</h5>
                                                            </div>
                                                            <div className="col-md-9">
                                                                <InputGroup
                                                                    className="mb-2"
                                                                    style={{ borderRadius: "10px" }}
                                                                >
                                                                    <Form.Control
                                                                        placeholder="www.google.com"
                                                                        value={getReelHostValue(data?.key)} // Bind the value dynamically
                                                                        onChange={(e) =>
                                                                            handleInputChange(1, data?.key, e.target.value)
                                                                        }
                                                                        aria-label="Amount (to the nearest dollar)"
                                                                    />
                                                                </InputGroup>
                                                            </div>
                                                        </>
                                                    })}
                                                    <div className="col-md-12">
                                                        <label>Playback M3U8 Enable</label>
                                                        <Switch
                                                            {...label}
                                                            checked={m3u8Enable}
                                                            onChange={e =>
                                                                setM3u8Enable(e?.target?.checked)
                                                            }
                                                            size='small'
                                                        />
                                                    </div>
                                                </div>
                                            </Form.Group>
                                        </Form>
                                    </div>
                                    <div className="col-md-6" style={{
                                        border: '1px solid #dbdbdb',
                                        borderRadius: '10px'
                                    }}>
                                        <Form>
                                            <Form.Group
                                                className='mb-3 ' style={{ display: 'grid', padding: '10px' }}
                                                controlId='exampleForm.ControlInput1'
                                            >
                                                <h5>Wowza Host*</h5>
                                                <div className="row">
                                                    {countryNetworkServiceProviderDataList?.map((data, index) => {
                                                        return < >
                                                            <div className="col-md-12">
                                                                <h5>{data?.value}</h5>
                                                            </div>
                                                            <div className="col-md-6">
                                                                <InputGroup
                                                                    className="mb-2"
                                                                    style={{ borderRadius: "10px" }}
                                                                >
                                                                    <Form.Control
                                                                        placeholder="www.google.com"
                                                                        value={getWowzaHostValue(data?.key, 'host')} // Bind the value dynamically
                                                                        onChange={(e) =>
                                                                            handleInputChange(2, data?.key, e.target.value, 'host')
                                                                        }
                                                                        // value={searchText}
                                                                        // onChange={(e) => setSearchText(e.target.value)}
                                                                        aria-label="Amount (to the nearest dollar)"
                                                                    />
                                                                </InputGroup>
                                                            </div>
                                                            <div className="col-md-6">
                                                                <InputGroup
                                                                    className="mb-2"
                                                                    style={{ borderRadius: "10px" }}
                                                                >
                                                                    <Form.Control
                                                                        placeholder="www.google.com"
                                                                        value={getWowzaHostValue(data?.key, 'playBackUrl')} // Bind the value dynamically
                                                                        onChange={(e) =>
                                                                            handleInputChange(2, data?.key, e.target.value, 'playBackUrl')
                                                                        }
                                                                        // value={searchText}
                                                                        // onChange={(e) => setSearchText(e.target.value)}
                                                                        aria-label="Amount (to the nearest dollar)"
                                                                    />
                                                                </InputGroup>
                                                            </div>
                                                        </>
                                                    })}
                                                </div>
                                            </Form.Group>
                                        </Form>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </>
}